
import 'selectize'
import objectAssign from 'object-assign'

export default function main (id, opts = {}) {
  return $('#' + id + '_tags').selectize(objectAssign({}, {
    plugins: ['remove_button'],
    createOnBlur: true,
    create: true,
    persist: false,
    valueField: 'name',
    labelField: 'name',
    searchField: 'name',
    render: {
      option: function(item, escape) {
        return '<div>' +
          escape(item.name) +
        '</div>';
      }
    },
    load: function(query, callback) {
      if (!query.length) return callback();

      var url = this.$input[0].getAttribute('data-queryurl');

      $.ajax({
          url: url,
          data: { prefix: query },
          type: 'GET',
          error: function() {
             callback();
          },
          success: function(res) {
            callback(res);
          }
      });
    }
  }, opts));
}
